"use client";
import { IProps } from "@/models";
import { useAppDispatch, useAppSelector } from "@/redux-store";
import { commonActions } from "@/redux-store/common.slice";
import { Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect } from "react";

const MainLayoutClient = ({ children }: MainLayoutProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery("(max-width: 991.98px)");
  const isShowFullMenu = useAppSelector(
    (state) => state.commonReducer.isShowFullMenu,
  );

  useEffect(() => {
    dispatch(commonActions.handleSetShowFullMenu(!isMobile));
  }, [dispatch, isMobile]);

  return (
    <Box
      className="main-right"
      pl={isMobile ? 0 : isShowFullMenu ? "270px" : "72px"}
    >
      {isMobile && isShowFullMenu ? (
        <Box
          className="fixed inset-0 bg-black/40 z-[190]"
          onClick={() => dispatch(commonActions.handleSetShowFullMenu(false))}
        />
      ) : null}
      {children}
    </Box>
  );
};

type MainLayoutProps = IProps;

export default MainLayoutClient;
